import { Component, Input, OnInit } from '@angular/core';

export type LinkCardContent = {
  href: string;
  title: [string, string?];
  text?: string;
  icon?: string;
};

@Component({
  selector: 'link-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent implements OnInit {
  @Input() content!: LinkCardContent;

  constructor() {}

  ngOnInit(): void {}
}
